<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Add zone</cll-dialog-title>
        <cll-dialog-subtitle>For {{ data.name }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <cll-form-field label="Zone name">
            <input cllFormInput [formControl]="zoneFormGroup.controls.name" type="text">
        </cll-form-field>
        <cll-form-field label="Zone description">
            <input cllFormInput [formControl]="zoneFormGroup.controls.description" type="text">
        </cll-form-field>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (addZoneRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="zoneFormGroup.invalid || this.addZoneRequest.loading()"
                (click)="add()">
            Create
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
